import { Avatar, AvatarGroup, Box, IconButton, InputAdornment, Typography } from '@mui/material';
import moment from 'moment';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { HiPaperAirplane } from 'react-icons/hi';
import { useSelector } from 'react-redux';
import theme from '../../muiTheme';
import CustomInput from '../Form/CustomInput';
import UserAvatar from '../UserAvatar/UserAvatar';

const ChatScreen = () => {

    const {chats, currentPage, numberOfPages, currentChat, currentMessagesPage, numberOfMessagesPages} = useSelector((state) => state.chatReducer);
    const [participantsString, setParticipantsString] = useState('');
    const [participants, setParticipants] = useState([]); 
    const {authData } = useSelector((state) => state.authReducer);
    const [inputMessage, setInputMessage] = useState('');
    let lastMoment = null; 

    useEffect(()=>{

        if(currentChat){

            let filteredParticipants = currentChat.participants.filter(participant => participant._id !== authData.result._id); 
            let participantsList = filteredParticipants.length > 1 ? filteredParticipants[0].name + ','+filteredParticipants[1].name : filteredParticipants[0].name;

            setParticipantsString(participantsList);
            setParticipants(filteredParticipants);
        }else {
            setParticipantsString('');
            setParticipants([]);
        }

    }, [currentChat]);


    const sendMessage = () => {

    }

    return (
        <Box
        
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'flex-start',
                width: '100%',
                height: '100%',
                overflowY: 'auto',
                position: 'relative'
            }}
        >

            <Box
                className='chat-header'
                sx={{
                    width: '100%',
                    height: '100px',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    padding: '20px',
                    boxSizing: 'border-box',
                    position: 'absolute',
                    top: '0px',
                    background: 'white'
                    
                }}
            >

                <AvatarGroup max={3}>

                {
                    participants.map((participant, index)=>(



                        <Avatar
                            key={'chat-'+currentChat._id+'-participant-'+participant._id}
                            alt={participant.name}
                            src={participant.profileImage}
                            sx={{
                                width: '60px',
                                height: '60px',
                                borderWidth: '4px'
                            }}
                        />
                    ))
                }
                </AvatarGroup>

                <Typography variant='h6' sx={{marginLeft: '20px'}}>
                    {participantsString}
                </Typography>

            </Box>

            <Box
            
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    width: '100%',
                    height: '100%',
                    overflowY: 'auto',
                    padding: '20px',
                    paddingBottom: '120px',
                    boxSizing: 'border-box'
                }}
            >


                {
                    currentChat.messages.map(message => {
                        
                        let alignment = (message.creator._id === authData.result._id ? 'flex-end' :'flex-start');
                        let borderBottomLeftRadius = (message.creator._id === authData.result._id ? '15px' :'3px');
                        let borderBottomRightRadius = (message.creator._id === authData.result._id ? '3px' :'15px');

                        let messageBackground = (message.creator._id === authData.result._id ? theme.palette.faint : theme.palette.lightGray);

                        let messageMoment = moment(message.createdAt).fromNow();

                        console.log('message moment: ', messageMoment, ' last moment: ', lastMoment);

                        if(messageMoment !== lastMoment){

                            lastMoment = messageMoment; 
                        }else {
                            messageMoment = null; 
                        }

                        console.log('resulting moment: ', messageMoment);
                        
                        return (
                            <Box

                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'flex-start',
                                    alignSelf: alignment,
                                    marginY: '5px',
                                }}
                            
                            >

                                { (message.creator._id !== authData.result._id) &&

                                    <UserAvatar
                                        url={`/profile/${message.creator._id}`}
                                        imageURL={message.creator.profileImage} 
                                        verified={message.creator.verified} 
                                        imageSx={{
                                            width: '50px',
                                            height: '50px'
                                        }} 
                                        nameSx={{}}
                                    />
                                }
                                

                                <Box
                                
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >

                                    <Box
                                    
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            background: messageBackground,
                                            borderRadius: '15px',
                                            padding: '10px',
                                            borderBottomLeftRadius,
                                            borderBottomRightRadius
                                        }}
                                    >

                                        <Typography>
                                            {message.message}
                                        </Typography>

                                    </Box>

                                    {
                                        messageMoment &&

                                        <Typography variant='subtitle2' sx={{alignSelf: alignment, fontSize: '12px', color: theme.palette.lightGray}}>
                                            {messageMoment}
                                        </Typography>
                                    }
                                    

                                </Box>

                            </Box>
                        )
                    
                                })
                }



            </Box>


            <Box
                className='chat-input'
                sx={{
                    width: '100%',
                    height: '100px',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    padding: '20px',
                    boxSizing: 'border-box',
                    position: 'absolute',
                    bottom: '0px',
                    background: 'white'
                    
                }}
            >

                <CustomInput 
                
                    fullWidth
                    rows={4}
                    variant='outlined'
                    label='Send a message!'
                    multiline
                    value={inputMessage}
                    onChange={e=>setInputMessage(e.target.value)}
                    endAdornment={{
                        endAdornment: (
                            <InputAdornment position='end'>

                                <IconButton
                                    color='primary'
                                    disabled={!inputMessage}
                                    onClick={sendMessage}
                                >

                                    <HiPaperAirplane style={{
                                        transform: 'rotate(90deg)'
                                    }} />
                                    
                                </IconButton>
                            </InputAdornment>
                        )
                    }}
                
                />

            </Box>



        </Box>
    ); 
}

export default ChatScreen; 